module.exports = __webpack_public_path__ + "static/media/فنادق جبال الالب في سويسرا.8ea7986b.jpg";